export default __webpack_public_path__ + "static/media/N.9f1a14c2.jpg";